/** Aba do painel do contador onde a pendência é resolvida. */
export type ParametrizationIssueGroup =
  | "CADASTRO"
  | "CERTIFICADO"
  | "NFE"
  | "NFCE"
  | "NFSE";

export type ParametrizationIssueSeverity = "ERRO" | "AVISO";

export interface ParametrizationIssue {
  grupo: ParametrizationIssueGroup;
  secao: string;
  campo: string;
  severidade: ParametrizationIssueSeverity;
  mensagem: string;
}

export interface ParametrizationIssuesResponse {
  verificadoEm: string;
  total: number;
  erros: number;
  avisos: number;
  pendencias: ParametrizationIssue[];
}

export const PARAMETRIZATION_GROUP_LABELS: Record<
  ParametrizationIssueGroup,
  string
> = {
  CADASTRO: "Meu CNPJ",
  CERTIFICADO: "Certificado digital",
  NFE: "NF-e",
  NFCE: "NFC-e",
  NFSE: "NFS-e"
};

export const PARAMETRIZATION_SEVERITY_LABELS: Record<
  ParametrizationIssueSeverity,
  string
> = {
  ERRO: "Erro",
  AVISO: "Aviso"
};
